import React from 'react'
import useStyles from './FormControlsCss';

export default function Heading(props) {
 
    let {field_label} = props
    
    const classes = useStyles();

    return ( 
        <div className={classes.inputroot}>
        <h3 className={classes.h3color}>{field_label}</h3>
        </div>
    )     
}
